<template>
  <h1 class="text-center text-bold text-black text-6xl bg-yellow-400"> Dashboard </h1>
  <div class='tableauPlaceholder'
  id='viz1648334809092'
  style='position: relative'>
  <noscript>
    <a href='#'>
      <img alt='Sheet 2 '
        src='https:&#47;&#47;
        public.tableau.com&#47;
        static&#47;images&#47;
        Ca&#47;CareonWheels&#47;
        Sheet2&#47;1_rss.png'
        style='border: none' />
        </a>
        </noscript>
        <object class='tableauViz'
          style='display:none;'>
          <param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F' />
          <param name='embed_code_version' value='3' />
          <param name='site_root' value='' />
          <param name='name' value='CareonWheels&#47;Sheet2' />
          <param name='tabs' value='no' />
          <param name='toolbar' value='yes' />
          <param name='static_image' value='https:&#47;&#47;public.tableau.com&#47;
            static&#47;images&#47;Ca&#47;CareonWheels&#47;Sheet2&#47;1.png' />
          <param name='animate_transition' value='yes' />
          <param name='display_static_image' value='yes' />
          <param name='display_spinner' value='yes' />
          <param name='display_overlay' value='yes' />
          <param name='display_count' value='yes' />
          <param name='language' value='en-US' />
          <param name='filter' value='publish=yes' />
          </object></div>
          <!-- <script type="application/javascript"> -->
</template>

<script>
import store from '@/store';

export default {
  name: 'Dashboard',
  beforeRouteEnter(to, from, next) {
    if (store.state.userLoggedIn) {
      next();
    } else {
      // redirect the user using the next function
      next({ name: 'home' });
      this.$router.go();
    }
  },
  mounted() {
    const divElement = document.getElementById('viz1648334809092');
    const vizElement = divElement.getElementsByTagName('object')[0];
    vizElement.style.width = '100%';
    vizElement.style.height = `${divElement.offsetWidth * 0.75}px`;
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
    vizElement.parentNode.insertBefore(scriptElement, vizElement);
  },
  // methods: {
  //   appScripts() {
  //     const divElement = document.getElementById('viz1648334809092');
  //     const vizElement = divElement.getElementsByTagName('object')[0];
  //     vizElement.style.width = '100%';
  //     vizElement.style.height = `${divElement.offsetWidth * 0.75}px`;
  //     const scriptElement = document.createElement('script');
  //     scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
  //     vizElement.parentNode.insertBefore(scriptElement, vizElement);
  //   },
  // },
};
</script>
